import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emptyList"},[_c('div',{staticClass:"elTitle"},[_vm._v(_vm._s(_vm.$t('UserStockWatchingList.emptyList.title')))]),_c('div',{staticClass:"elDesc"},[_vm._v(_vm._s(_vm.$t('UserStockWatchingList.emptyList.text')))]),_c(VBtn,{attrs:{"color":"blue darken-4","dark":"","fab":""},on:{"click":_vm.addClicked}},[_c('font-awesome-icon',{staticClass:"fa-fw fa-2x",attrs:{"icon":_vm.icons.add}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }